import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-quill/dist/quill.snow.css";
import "./index.css";

// Brand colors are set per-project in .env (REACT_APP_COLOR_*) and override
// the defaults in src/styles/colors.module.css at runtime - this now lives in
// ThemeModeContext (src/contexts/ThemeModeContext.js) instead of running once
// here, so it can also react to light/dark mode changes.

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
